import VueAppleLogin from 'vue-apple-login';
import { checkURL } from '~/composables/useAuth';

export default defineNuxtPlugin(nuxtApp => {
  const config = useRuntimeConfig();
  
  nuxtApp.vueApp.use(VueAppleLogin, {
    clientId: config.public.VITE_APPLE_LOGIN_CLIENT_ID,
    scope: 'name email',
    redirectURI: `${checkURL()}/callbackApple`,
    state: JSON.stringify({ param: 'dynamic.value' }),
    usePopup: true
  })
});